import { render, staticRenderFns } from "./AdminPanelBanners.vue?vue&type=template&id=7c6e2354&scoped=true"
import script from "./AdminPanelBanners.vue?vue&type=script&lang=js"
export * from "./AdminPanelBanners.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelBanners.vue?vue&type=style&index=0&id=7c6e2354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e2354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
